if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        // Closing the zoom re-focuses the image button that opened it. Browsers
        // scroll an overflow:hidden box (our sticky .product__media-wrapper) to
        // reveal a focused child, which left the stacked images shifted/cropped.
        // Remember the page scroll, close, then put every gallery box back at 0.
        const scrollX = window.scrollX;
        const scrollY = window.scrollY;

        super.hide();

        document
          .querySelectorAll('.product__media-wrapper, media-gallery, slider-component, .product__media-list')
          .forEach((el) => {
            if (el.scrollTop) el.scrollTop = 0;
            if (el.scrollLeft && !el.matches('.product__media-list')) el.scrollLeft = 0;
          });

        if (window.scrollY !== scrollY || window.scrollX !== scrollX) {
          window.scrollTo({ top: scrollY, left: scrollX, behavior: 'instant' });
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}